import { motion, type HTMLMotionProps } from "motion/react";
import { EASE, REVEAL_DURATION } from "./tokens";

type RevealProps = HTMLMotionProps<"div"> & {
  /** vertical travel in px (default 16) */
  y?: number;
  /** seconds before the reveal starts */
  delay?: number;
  /** fraction visible before triggering (default 0.2) */
  amount?: number;
};

/**
 * Scroll-triggered rise + fade, fired once when the element enters the viewport.
 * Use for heading groups and standalone content blocks; for staggered lists use
 * `staggerContainer` + `staggerItem` (from ./tokens) directly on the list/items.
 *
 * Reduced motion is handled globally by the <MotionConfig reducedMotion="user">
 * wrapper on the landing page (transforms skipped to final value, opacity still
 * fades), so this needs no per-call guard.
 */
export function Reveal({ y = 16, delay = 0, amount = 0.2, children, ...rest }: RevealProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: REVEAL_DURATION, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
